import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const useActiveDataLakeBackendType = () => {
  const { data, isSuccess, error } = useQuery({
    queryKey: [...DATA_LAKE_CONFIG_QUERY_KEYS, "active", "type"],
    queryFn: () => defaultOnError(
      DataLakeBackends.getActiveBackendType(),
      i18n.t("notifications.fetch_active_backend_type_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_active_backend_type_failed_title", { ns: "enterprise_data_lake" })
    )
  });
  return {
    data: data == null ? void 0 : data.type,
    isSuccess,
    error
  };
};
export default useActiveDataLakeBackendType;
